import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { Box, Grid, Button } from "@material-ui/core";
import { MutantApiService } from "../../services/MutantApiService";
import { StyledCardBody } from "../../pages/admin/components/AdminCard/style";
import { Card } from "react-bootstrap";
import { ReactComponent as LogoMutant } from "../../../app/assets/logos/logo-mutant.svg";
import styled from "styled-components";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import moment from 'moment';
import { ReactComponent as ExitIcon } from "../../../app/assets/icons/icon_exit.svg";
import store from "../../../app/store/store";
import * as authDuck from "../../../app/store/ducks/auth.duck";


const StyledLogo = styled(LogoMutant)`
	height: 20px;
	fill: #fff;
	margin-left: 30px;

	&:hover {
		background-color: rgba(0, 0, 0, 0.2);
	}
`;

export function MaintenancePage() {
	const history = useHistory();
	const api = new MutantApiService();
	const [info, setInfo] = useState({});
	const [timeLeft, setTimeLeft] = useState("");
	const [decodedMessage, setDecodedMessage] = useState("");

	const handleLogout = async () => {
		const api = new MutantApiService();
		store.dispatch(authDuck.actions.logout());
		try{
			await api.makeHttpRequest({
				url: "/auth/logout",
				method: "POST"
			});
		} catch (error) {
			console.error('Erro ao fazer logout', error);
		}

		history.push("/login");
	};

	useEffect(() => {
		let maintenanceIntervalId;
		let settingsIntervalId;

		const fetchMaintenanceData = async () => {
			try {
				const maintenanceData = await api.makeHttpRequest({
					url: `/maintenance`,
					method: "GET"
				});
				if (!maintenanceData){
					window.location.href = '/auth/login';
				}
				setInfo(maintenanceData);
				try {
					setDecodedMessage(atob(maintenanceData?.message));
				} catch (e) {
					console.error("fetchMaintenanceData error", e);
					setDecodedMessage(maintenanceData?.message);
				}
			} catch (error) {
				console.error('Erro ao buscar dados de manutenção', error);
			}
		};

		const checkMaintenanceMode = async () => {
			try {
				const settings = await api.makeHttpRequest({
					url: `/settings`,
					method: "GET"
				});

				if (!settings.maintenanceMode) {
					history.push('/dashboard/projects');
				}
			} catch (error) {
				console.error('Erro ao verificar o modo de manutenção', error);
			}
		};

		fetchMaintenanceData();
		checkMaintenanceMode();

		maintenanceIntervalId = setInterval(fetchMaintenanceData, 5000);
		settingsIntervalId = setInterval(checkMaintenanceMode, 5000);

		return () => {
			clearInterval(maintenanceIntervalId);
			clearInterval(settingsIntervalId);
		};
	}, []);

	useEffect(() => {
		const updateTimer = () => {
			const endTime = moment(info.endDateTime);
			if (moment().isBefore(endTime)) {
				const duration = moment.duration(endTime.diff(moment()));
				setTimeLeft(`${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s`);
			} else {
				setTimeLeft("encerrado");
			}
		};

		if (info.endDateTime) {
			updateTimer();
			const timerId = setInterval(updateTimer, 1000);
			return () => clearInterval(timerId);
		}
	}, [info.endDateTime]);

	return (
		<Box height="100vh" width="100vw">
			<Box
				display="flex"
				justifyContent="flex-start"
				alignItems="center"
				height="50px"
				width="100%"
				border="1px solid #E5E5E5"
				style={{
					backgroundColor: '#213F5B',
					border: 'none',
					borderBottom: '1px solid #E5E5E5'
				}}
			>
				<Link to="/dashboard/projects">
					<StyledLogo
						fill="#FFFFFF"
						color="#FFF"
						style={{
							height: "20px",
							marginLeft: "30px"
						}}
					/>
				</Link>
				<Button
					style={{
						border: 'none',
						marginLeft: 'auto',
						marginRight: '20px'
					}}
					onClick={handleLogout}
				>
					<ExitIcon />
				</Button>
			</Box>

			<Card className="mt-4">
				<StyledCardBody
					style={{
						minHeight: "400px",
						display: "flex",
						alignItems: "flex-start"
					}}
				>
					<Grid container sm={12} xs={12} spacing={3}>
						<Grid item xs={12} sm={12}>
							<Box
								style={{
									border: '1px solid #5c5c5c',
									borderRadius: '5px',
									padding: '10px',
									marginBottom: '20px',
								}}
							>
								<div className="rdw-storybook-root" dangerouslySetInnerHTML={{ __html: decodedMessage }} />
							</Box>
						</Grid>
						<Box>
							<p>Início da manutenção: {moment(info.startDateTime).format('DD/MM/YYYY HH:mm:ss')}</p>
							<p>Fim previsto da manutenção: {moment(info.endDateTime).format('DD/MM/YYYY HH:mm:ss')}</p>
							<p>Tempo restante previsto: {timeLeft}</p>
						</Box>
					</Grid>
				</StyledCardBody>
			</Card>
		</Box>
	);
}

export default MaintenancePage;
